"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Scrapbook = function Scrapbook(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.586 95.414A1.994 1.994 0 0 1 15 94v-6a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1h67V22h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6c.552 0 1.052.224 1.414.586.362.362.586.862.586 1.414v77c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0 1 94 96H17a1.994 1.994 0 0 1-1.414-.586zm66.416-41.597L82 53.82V80a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h78a2 2 0 0 1 2 2v51.816zM75 47.465V7H7v68h5.05l43.035-43.035a2 2 0 0 1 2.759-.067L75 47.465zm0 9.452L56.667 40.282 21.95 75H75V56.917zM26.5 36.5c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zm0-5.882a4.118 4.118 0 1 0 0-8.236 4.118 4.118 0 0 0 0 8.236z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Scrapbook;